/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other Libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import './vendor';

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
import Panel from './components/Panel.vue';
//import BModal from './components/Modal.vue';
import Access from './utility/access';
import Select2 from './form/dropdown/select2.vue';
import MultiSelect from './form/dropdown/multi_select.vue';
import Switchery from './form/checkbox/switchery.vue';
import StateSelect from './form/dropdown/state_select.vue';
import StyledCheckbox from './form/checkbox/styled.vue';
import './form/masks/zipcode';
import Tabs from './components/tabs/tabs.vue';
import Tab from './components/tabs/tab.vue';
import StatusLabel from './form/status/status_label.vue';
import FormGroup from './form/form_group/form_group.vue';
import InvDropzone from './form/files/dropzone.vue';
import InvDataTable from './components/table/datatable.vue';
import ActionButton from './components/ActionButtons.vue';
import Tabs2 from './components/tabs2/tabs.vue';
import Tab2 from './components/tabs2/tab.vue';
import Loader from './components/Loader.vue';
let perms = [];

if (PAGE_CONFIG.perms) {
    perms = PAGE_CONFIG.perms;
}
window.inv_dropzone = InvDropzone;
window.inv_dt = InvDataTable;
window.Access = new Access(perms);

Vue.config.productionTip = false;

Vue.component('panel', Panel);
Vue.component('select2', Select2);
Vue.component('multi-select', MultiSelect);
Vue.component('checkbox', Switchery);
Vue.component('state-select', StateSelect);
Vue.component('styled-checkbox', StyledCheckbox);
Vue.component('tabs', Tabs);
Vue.component('tab', Tab);
Vue.component('tabs2', Tabs2);
Vue.component('tab2', Tab2)
Vue.component('status-label', StatusLabel);
Vue.component('form-group', FormGroup);
Vue.component('action-button', ActionButton);
Vue.component('loader', Loader);
/**
 * Setup global vue mixins
 */
import AccessMixin from './mixin/access';
import MiscMixin from './mixin/misc';

import Form from './utility/Form';
window.Form = Form;

import Form2 from './utility/Form2';
window.Form2 = Form2;

/**
 * Global vue filters
 */
import InvFilters from './filters/filters';
Vue.use(InvFilters);